import * as actionTypes from './actionTypes';

export const fetchMyDashboard = () => ({
  type: actionTypes.FETCH,
});
export const fetchMyDashboardSuccess = (id) => ({
  type: actionTypes.FETCH_SUCCESS,
  id,
});
export const fetchMyDashboardError = (error) => ({
  type: actionTypes.FETCH_ERROR,
  error,
});


export const createMyDashboard = (dashboard) => ({
  type: actionTypes.CREATE,
  dashboard,
});
export const createMyDashboardSuccess = (id) => ({
  type: actionTypes.CREATE_SUCCESS,
  id,
});
export const createMyDashboardError = (error) => ({
  type: actionTypes.CREATE_ERROR,
  error,
});


export const updateMyDashboard = (dashboard) => ({
  type: actionTypes.UPDATE,
  dashboard,
});
export const updateMyDashboardSuccess = (id) => ({
  type: actionTypes.UPDATE_SUCCESS,
  id,
});
export const updateMyDashboardError = (error) => ({
  type: actionTypes.UPDATE_ERROR,
  error,
});

export const setMyDashboardCurrentBreakpoint = (breakpoint) => ({
  type: actionTypes.SET_CURRENT_BREAKPOINT,
  breakpoint,
});
